// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"940bfd74","567":"099c8f64"}[chunkId] + ".chunk.js";
};